import React, { useState, useEffect } from 'react';
import { withTranslation } from "react-i18next";
import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup } from "react-simple-maps";
import ReactTooltip from "react-tooltip";
import "./WorldMap.scss";
import * as TopologyJSON from "./topology.json";

const CountryLatLongData = require("./country-lat-long.json");
const legendMarkers = [
	{ baseColor: 'red', color: '#fb8d75', label: "High.label" },
	{ baseColor: 'yellow', color: '#ffca73', label: "Medium.label" },
	{ baseColor: 'green', color: '#b5d376', label: "Low.label" }
];

const WorldMap = ({ t, chartData }) => {

	const [tooltipContent, setTooltipContent] = useState(null);
	const [chartMarkers, setChartMarkers] = useState([]);

	useEffect(() => {
		const markers = []
		chartData?.forEach(d => {
			markers.push({
				country: d,
				coordinates: getCountryCoordinates(d.code)
			});
		});
		setChartMarkers(markers);
	}, [chartData]);

	const getCountryCoordinates = (code) => {
		const country = CountryLatLongData?.country_codes?.find(c => c.alpha2 === code || c.alpha3 === code);
		return country ? [country.longitude, country.latitude] : null;
	};

	const showTooltipForCountry = (country) => {
		if (country) {
			let html = `
				<div style="font-weight: bold;margin-bottom: 2px;">${country.country}</div>
				<table><tbody>
			`;
			html += `<tr><td style="padding-right: 5px;">${country.total}</td><td>Total</td></tr>`;
			country.supplierCounts?.forEach(sc => {
				html += `<tr><td style="padding-right: 5px;">${sc.count}</td><td>${sc.type} risk</td></tr>`;
			});
			html += `</tbody></table>`;
			setTooltipContent(html);
		} else {
			setTooltipContent(null);
		}
	};

	return (
		<div data-tip="">
			<ComposableMap height={550}>
				<ZoomableGroup>
					<Geographies geography={TopologyJSON}>
						{({ geographies }) =>
							geographies.map((geo) => {			
								const country = chartData.find(c => c.code === geo.id || c.country === geo.properties.name);
								return <Geography
									key={geo.rsmKey}
									geography={geo}
									onMouseEnter={() => { showTooltipForCountry(country); }}
									onMouseLeave={() => { setTooltipContent(null); }}
									stroke="#FFF"
									fill={country
										? legendMarkers.find(m => m.baseColor === country.color)?.color ?? ''
										: '#D6D6DA'
									}
									style={{
										default: {
											outline: "none"
										},
										hover: {
											outline: "none"
										},
										pressed: {
											outline: "none"
										}
									}}
								/>
							})
						}
					</Geographies>
					{chartMarkers.map(({ country, coordinates }) => {
						return (coordinates &&
							<Marker key={country.country}
								coordinates={coordinates}
								onMouseEnter={() => { showTooltipForCountry(country); }}
								onMouseLeave={() => { setTooltipContent(null); }}>
								<circle opacity={0.8} r={10} fill="white" stroke="#fff" strokeWidth={1} />
								<text textAnchor="middle" style={{ fontSize: "10px" }}>{country?.total}</text>
							</Marker>
						);
					})}
				</ZoomableGroup>
			</ComposableMap>
			<ReactTooltip backgroundColor="white" textColor="black" html={true}>{tooltipContent}</ReactTooltip>
			{
				chartData && 
				<div id="countryRiskLegend">
					{
						legendMarkers.map((legend, index) => {
							return (
								<div key={index} className="legend-marker">
									<span className="legend-marker-color" style={{ backgroundColor: legend.color }}></span>
									<span>{t(legend.label)}</span>
								</div>
							);
						})
					}
				</div>
			}
		</div>
	);
};

export default withTranslation()(WorldMap);